<template>
    <!-- Start Main Content -->
    <div
        class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">

        <!-- Add notice form -->
        <div v-if="isMember" class="card p-4 lg:p-6">
            <h6 class="card-title">Add Member</h6>
            <form>
                 <div class="grid grid-cols-12 gap-x-4 gap-y-5 mt-7 pt-0.5" v-on:keyup.enter="nextFocus">

                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">Member ID *</label>
                        <input type="number" v-model="customer.memberid"  @input="updatePackageMemberId" placeholder="Type Here"
                            class="form-input" required autocomplete="off" readonly>
                    </div>



                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">First Name *</label>
                        <input type="text" v-model="customer.firstname" placeholder="Type Here"
                            class="form-input" required autocomplete="off">
                    </div>
                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">Last Name *</label>
                        <input type="text" v-model="customer.lastname" placeholder="Type Here" class="form-input" required
                            autocomplete="off">
                    </div>

    


                       <!-- frsit -->

                       <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">Date Of Birth *</label>
                        <input type="date" v-model="customer.dob" placeholder="Type Here"
                            class="form-input" required autocomplete="off">
                    </div>

                    
                    <div class="col-span-full  lg:col-span-4 leading-none">
                        <label class="form-label">Gender *</label>
                        <select class="form-input" v-model="customer.gender">
                            <option DISABLED value="0">SELECT GENDER</option>

                            <option value="male">Male</option>
                            <option value="female">Female</option>

                            <!-- <option v-for="(item, index)  in packageList" :value="item.id">{{ item.name }}</option> -->
                             
                        </select>
                    </div> 



                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">Address *</label>
                        <input type="text" v-model="customer.address" placeholder="Type Here" class="form-input" required
                            autocomplete="off">
                    </div>





                        <!-- end -->



                    <!-- frsit city-->

                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">City *</label>
                        <input type="text" v-model="customer.city" placeholder="Type Here"
                            class="form-input" required autocomplete="off" readonly>
                    </div>

                    
                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">State *</label>
                        <input type="text" v-model="customer.state" placeholder="Type Here" class="form-input" required
                            autocomplete="off" readonly>
                    </div>



                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">Phone Number *</label>
                        <input type="number" v-model="customer.phonenumber" placeholder="Type Here" class="form-input" required
                            autocomplete="off">
                    </div>





                        <!-- end phone-->





                    <!-- frsit Email-->

                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">Email Address *</label>
                        <input type="text" v-model="customer.email" placeholder="Type Here"
                            class="form-input" required autocomplete="off">
                    </div>

                    
                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">Emergency Contact *</label>
                        <input type="number" v-model="customer.emergency" placeholder="Type Here" class="form-input" required
                            autocomplete="off">
                    </div>



                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">Health issues *</label>
                        <input type="text" v-model="customer.health" placeholder="Type Here" class="form-input" required
                            autocomplete="off">
                    </div>
                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">Aadhar Card No *</label>
                        <input type="text" v-model="customer.aadharno" placeholder="Type Here" class="form-input" required
                            autocomplete="off">
                    </div>


                </div>
            </form>
          
   
           
            <button @click="SelectPackage" v-if="!isUpdate" class="btn b-solid btn-primary-solid px-5 cursor-pointer mt-6" >
                Process
            </button>
            
            <button @click="saveMember"  v-if="isUpdate" class="btn b-solid btn-primary-solid px-5 cursor-pointer mt-6 ml-3"> 
                <i class="fa fa-left-arrow"></i> Update
            </button>

        </div>

        <div v-else class="card p-0 lg:min-h-[calc(100vh_-_theme('spacing.header')_*_1.4)] xl:min-h-[calc(100vh_-_theme('spacing.header')_*_1.6)]">
                <div class="flex flex-col gap-2 sm:flex-center-between sm:flex-row px-4 py-5 sm:p-7 bg-gray-200/30 dark:bg-dark-card-shade">
                    <div>
                        <h6 class="card-title">Select Package</h6>
                    </div>
                   
                </div>
                <!-- Start All Language List Table -->
                <div class="p-3 sm:p-4">
                   <div class="flex flex-wrap gap-4 overflow-x-auto scrollbar-table">
                       <div 
                           class="bg-white dark:bg-dark-bg rounded-lg shadow-md overflow-hidden w-72" 
                           v-for="(item, index) in packageList" 
                           :key="item.id"
                       >
                           <div :class="item.id==_package.packageid? 'sele_card p-4':'p-4'">
                               <h3 class="font-semibold text-lg text-gray-700 dark:text-dark-text">{{ item.name }}</h3>
                               <p class="text-gray-500 dark:text-dark-secondary">Rate: {{ item.cost }}</p>
                               <p class="text-gray-500 dark:text-dark-secondary">Days : {{ item.days }}</p>
                               <p class="text-gray-500 dark:text-dark-secondary">description: {{ item.description }}</p>
                               <!-- <p class="text-gray-500 dark:text-dark-secondary">Status: {{ item.status }}</p> -->
                           </div>
                           <div class="flex justify-center p-4 border-t border-gray-200 dark:border-dark-border">
                               <button 
                                   class="btn-select" 
                                   @click="select_this_Package(item)"
                               >
                                   Select
                               </button>
                           </div>
                       </div>
                   </div>
               </div>



               <!-- start -->


          <div mt-2>
                 <div class="grid grid-cols-12 gap-x-4 gap-y-5 mt-7 pt-0.5" v-on:keyup.enter="nextFocus">
                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label ml-3">Start Date *</label>
                        <input type="date" v-model="_package.startdate" :max="_package.startdate" placeholder="Type Here"
                            class="form-input ml-4" required autocomplete="off">
                    </div>
                    

                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label ml-4">Total *</label>
                        <input type="number" v-model="_package.total" placeholder="Type Here" readonly=""
                            class="form-input  ml-3" required autocomplete="off">
                    </div>

                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label ml-3">Paid *</label>
                        <input type="number" v-model="_package.paid" placeholder="Type Here"
                            class="form-input ml-3" required autocomplete="off">
                    </div>

                    <div class="col-span-full lg:col-span-4 leading-none ml-3">
                        <label class="form-label">Payment Type *</label>
                        <select class="form-input" v-model="_package.paymenttype">
                            <option disabled value="0">SELECT Payment Type</option>
                            <option value="Cash">Cash</option>
                            <option value="Cheque">Cheque</option>
                            <option value="Upi">Upi</option>
                            <option value="Bajaj Finance">Bajaj Finance</option>
                            <option value="Credit_Debit Card">Credit/Debit Card</option>
                            <!-- <option v-for="(item, index) in _packageList" :value="item.id">{{ item.name }}</option> -->
                        </select>
                    </div>
                    

                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label ml-3">Note *</label>
                        <input type="text" v-model="_package.note" placeholder="Type Here"
                            class="form-input ml-3" required autocomplete="off">
                    </div>
  
  
               </div>

               </div>
 
           <!-- end  -->








<div v-if='loading'>
    {{loading}}
</div>
               
               <button @click="SelectPackage" class="btn b-solid btn-primary-solid px-5 cursor-pointer mt-6 ml-3">
                <i class="fa fa-left-arrow"></i> Go Back
            </button>
            
            
            <button @click="save" v-if="!isUpdate" class="btn b-solid btn-success-solid px-5 cursor-pointer mt-6 ml-3"> 
                <i class="fa fa-left-arrow"></i> Save
            </button>
            
            <button @click="resetForm" v-if="isSaved" class="btn b-solid btn-danger-solid px-5 cursor-pointer mt-6 ml-3"> 
                <i class="fa fa-left-arrow"></i> New Entry
            </button>
            
                <!-- End All Language List Table -->
            </div>
        </div>

 

</template>
<style scoped>
.sele_card{
    background: #f9bb6f;
}
</style>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import axios from 'axios';

export default {
    name: 'AddProduct',
    components: {

    },
    
    mounted() {
         
        if (this.$route.query.id) {
            const customerId = this.$route.query.id;
            this.isUpdate=true
            this.fetchCustomerData(customerId);
        }else
        this.getBasics(); 
    }, 
    data() {
        return {
            isMember:true,
            isAdd: 0,
            isEdit: 0,
            isDelete: 0,
            deleteId: 0,
            isUpdate:false,
            isSaved:false,
            packageList: [],
            // customer: { name: '', cat: '0', barcode: '', hsn: '', descr: '', gst: '5', unit: '', mrp: '0', prate: '0', salerate: '0', set_rate: '0', set_qty: '0', op_qty: 0 },
            // employees: { empname: '', emprole: '0', isMainAdmin: 0 },
 
            loading:'',

           _package: {
            startdate:  new Date().toISOString().split('T')[0],
            total: '',
            paid: '',
            note: '',
            memberid: '',
            paymenttype: '',
            packageid:'',

           },
           

            customer: { 
                memberid: '',
                firstname: '',
                lastname:'',
                dob: '',
                gender: '',
                address: '',
                city: 'Solapur',
                state: 'Maharashtra',
                phonenumber: '',
                email: '',
                emergency: '', 
                aadharno:''          
            },



        }
    
    },
    computed: {
    btnSave() {
      return this.$route.query.id ? "Update" : "Save";
    }
  },
    created() {
       
    },
    methods: {
        resetForm(){
            window.location.reload();
        },
        fetchCustomerData(id) {
            var self=this;
            axios.get(`getCustomerData/${id}`)
                .then(response => {
                    self.customer = response.data.data; 
                    self.customer.memberid=self.customer.memberid;
                })
                .catch(error => {
                    console.error('Error fetching customer data:', error);
                });
        },

        updatePackageMemberId() {
       this._package.memberid = this.customer.memberid;
    },

        SelectPackage(){
            this.isMember=!this.isMember;
        },
        select_this_Package(item) {
            this._package.packageid=item.id;
            this._package.total = item.cost; // Set the total to the package cost
        },
        
        async getBasics() {
            var self = this;
            axios.post('getBasicForCustomer').then(function (response) {
                self.packageList = response.data.packages;
                self.customer.memberid = response.data.memberid;
                self.employees = response.data.userDetails;
            });
        },
        nextFocus(e) {
            const inputs = Array.from(e.target.form.querySelectorAll('input,select,button'));
            const index = inputs.indexOf(e.target);

            if (index < inputs.length) {
                try {
                    inputs[index + 1].focus();
                    inputs[index + 1].select();
                } catch (error) {
                    $("#saveBtn").focus();
                }
            }
        },
        openInNewTab(id) {
            const url = `${window.location.origin}/#/invoice/print?id=${id}`;
            const newWindow = window.open(url, '_blank');
            
            // Ensure the new tab is opened before triggering print
            if (newWindow) {
              newWindow.focus();
            } else {
              alert("Popup blocked. Please allow popups for this site.");
            }
            
            
          
            },
       save() {
            var self = this;
            if (self.customer.FristName == '') 
                self.$swal("Product Name is Required");
            else if (self.customer.firstname == '') 
                self.$swal("FirstName is Required"); 
            else {
                
                self.loading="Please Wait, Saving.... ";
                self.$swal({
                    title: "Do You Want To Save?",
                    text: "Are you sure? ",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "Yes"
                }).then((result) => { // <--
                        
                        self.loading="";
                    if (result.value) { // <-- if confirmed
                        axios.post('addcustomer', {cust:JSON.stringify(this.customer),pkg:JSON.stringify(this._package)})
                            .then(response => {
                                var msg = response.data.msg;
                                var isSuccess = response.data.status;
                                
                                //self.packageList = response.data.cats;
                               // self.employees = response.data.userDetails;
                               // self.cat = { name: '', status: 'Active' };
                                 self.$swal(msg);
                                if (isSuccess == 1) {
                                    self.isSaved=true;
                                    self.customer = {  memberid: '',
                firstname: '',
                lastname:'',
                dob: '',
                gender: '',
                address: '',
                city: 'Solapur',
                state: 'Maharashtra',
                phonenumber: '',
                email: '',
                emergency: '', 
                aadharno:''     };
                                    self.openInNewTab(response.data.sub_id);

                                }

                                // Now, perform another axios post for a package operation

                                


                              

                            })
                            .catch(error => {
                                console.log('Error on Authentication: ' + error);
                            });
                    }
                });
            }

        },
        saveMember() {
            var self = this;
             self.loading="Please Wait, Updateing.... ";
            if (self.customer.firstname == '') 
                self.$swal("FirstName is Required"); 
            else {
                self.$swal({
                    title: "Do You Want To Save?",
                    text: "Are you sure? ",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "Yes"
                }).then((result) => { // <--
                    self.loading="";
                    if (result.value) { // <-- if confirmed
                        axios.post('updatecustomer', {cust:JSON.stringify(this.customer)})
                            .then(response => {
                                var msg = response.data.msg;
                                var isSuccess = response.data.status;
                                //self.packageList = response.data.cats;
                               // self.employees = response.data.userDetails;
                               // self.cat = { name: '', status: 'Active' };
                                if (isSuccess == 1) {
                                    self.customer = { memberid: '', firstname: '',lastname: '', gender: '', address: '', city: '', state: '', phonenumber: '', email: '', emergency: ''};
                                 

                                }

                                // Now, perform another axios post for a package operation

                                


                                self.$swal(msg);

                            })
                            .catch(error => {
                                console.log('Error on Authentication: ' + error);
                            });
                    }
                });
            }

        }
    }


    // end-----------------------------------------------------
}
</script>
